import React from 'react';

import { CircularProgress, Typography } from '@mui/material';

import { useGetOrderItemV2 } from '~/hooks/apis/business-traveller/useOrderItemTravellerCredit';

import { formatCurrency } from '~/utils/currencyFormatter';

interface Props {
  orderItemId: string;
  currencyCode: string;
  /** Text alignment for the credit amount display */
  align?: 'start' | 'end';
}

/** Displays the total business credits earned across all travellers on the order item */
export default function OrderItemTotalBusinessCredit({ orderItemId, currencyCode, align = 'start' }: Props) {
  const { data: orderItem, isLoading } = useGetOrderItemV2({ orderItemId });

  if (isLoading) {
    return <CircularProgress size={14} />;
  }

  if (!orderItem?.travellers) {
    return null;
  }

  const totalCredits = orderItem.travellers.reduce((sum, traveller) => sum + traveller.credits, 0);

  return (
    <Typography sx={{ display: 'flex', justifyContent: align }}>
      Business Credits: {formatCurrency(totalCredits, currencyCode, 'en-AU')}
    </Typography>
  );
}
